const apiClient = require('../graphql/apiClient')
const { hideRadarArea, isViewEnabled, initialisePage, hideLoader, getRootContent } = require('../utils/headers')
const { getCellColor, getTableHeadingRow, findLastPublishedRecord } = require('../utils/formattingUtils')

const _ = require('lodash')

const { gql } = require('graphql-tag')

const OFF_RADAR_QUERY = gql`
  query offRadar($statuses: [Status]) {
    blips(statuses: $statuses) {
      id
      name
      link
      labels
      quadrant {
        name
      }
      updated
      history {
        publicationName
        status
      }
    }
  }
`

const VIEW_MODE = 'off_radar'

function renderView() {
  if (isViewEnabled(VIEW_MODE)) {
    hideRadarArea()

    initialisePage('Off Radar', 'Blips that have been removed from the radar to remove noise.  These blips may reappear if and when new information becomes available.')

    let bodyText = ''

    apiClient(OFF_RADAR_QUERY, {
      statuses: ['OFF_RADAR'],
    })
      .then((res) => res.json())
      .then((result) => {
        const data = result.data.blips
        const sortedData = _.sortBy(data, ['quadrant.name', 'name'])
        const groupedBlips = _(sortedData)
          .groupBy((blip) => blip.quadrant.name)
          .value()

        bodyText += '<table>'
        bodyText += getTableHeadingRow(groupedBlips)
        bodyText += '<tr>'

        let colorIndex = 0

        _.map(groupedBlips, function (value) {
          bodyText += `<td style="background-color: ${getCellColor(colorIndex)};">`

          _.each(value, function (blip) {
            let lastSeen = findLastPublishedRecord(blip)

            bodyText += `<div>
              <a href="${blip.link}" target="_blank">${blip.id}</a>: ${blip.name}<br />
              <div style="margin-left: 5px;">
                  <font size="2">
                    <div><strong>Retired: </strong><i> on ${new Date(blip.updated).toDateString()}</i></div>`

            if (lastSeen) {
              bodyText += `<strong>Last Publication: </strong><i>${lastSeen.publicationName} as ${lastSeen.status}</i>`
            }

            bodyText += `<div><strong>Labels: </strong><i>${blip.labels.join(", ")}</i></div>
                  </font >
                </div >
              </div>
            <br />`
          })
          colorIndex += 1
          bodyText += '</td>'
        })

        bodyText += '</tr></table>'
      })
      .then(() => {
        hideLoader()
        getRootContent().append('div').attr('id', 'radar-table').append('div').attr('id', 'off-radar-blips').html(bodyText)
      })
  }
}

module.exports = renderView
